import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../../auth/AuthProvider.jsx';
import LoadingSpinner from '../common/LoadingSpinner.jsx';
import Logger from '../../utils/logger.js';

const ProtectedRoute = ({
  children,
  requiredRole,
  requiredPermission,
  requiredRoles = [],
  requiredPermissions = [],
  requireAll = false
}) => {
  const { isAuthenticated, isLoading, hasRole, hasPermission } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner message="Verifying authentication..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check single role requirement
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Check single permission requirement
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Check multiple roles
  if (requiredRoles.length > 0) {
    const hasRequiredRoles = requireAll
      ? requiredRoles.every(role => hasRole(role))
      : requiredRoles.some(role => hasRole(role));

    if (!hasRequiredRoles) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Check multiple permissions
  if (requiredPermissions.length > 0) {
    const hasRequiredPermissions = requireAll
      ? requiredPermissions.every(perm => hasPermission(perm))
      : requiredPermissions.some(perm => hasPermission(perm));

    // Debug logging

    Logger.debug('ProtectedRoute - Required permissions:', requiredPermissions);

    Logger.debug('ProtectedRoute - Has required permissions:', hasRequiredPermissions);

    Logger.debug('ProtectedRoute - Checking with requireAll:', requireAll);

    if (!hasRequiredPermissions) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
